import { readState } from "@/__main__/app-state.mjs";
import { MATCH_LIMIT } from "@/game-tft/constants.mjs";
import { useSnapshot } from "@/util/use-snapshot.mjs";

function getParticipant(match, fullName) {
  return match.info.participants.find((participant) => {
    const { game_name, tag_line } = participant.BLITZ_riot_account.account;
    return `${game_name}-${tag_line}` === fullName;
  });
}

const sumReduce = (a, v) => a + v;

export default function useMatchListStats(fullName) {
  const {
    tft: { matchLists_v2, matches_v2 },
  } = useSnapshot(readState);
  const r = {
    placements: new Array(MATCH_LIMIT).fill(null),
    avgPlacement: 0,
    count: 0,
    traits: [],
    units: [],
  };
  const traitsHash = {};
  const unitsHash = {};
  const matchList = matchLists_v2[fullName];
  if (!matchList || matchList instanceof Error) return r;
  for (let i = 0; i < MATCH_LIMIT; i++) {
    const matchId = matchList[i];
    const match = matches_v2[matchId];
    if (!match || match instanceof Error) continue;
    const participant = getParticipant(match, fullName);
    if (!participant) continue;
    r.placements[i] = participant.placement;
    for (const t of participant.traits) {
      if (t.tier_current === 0) continue;
      if (!traitsHash[t.name]) {
        traitsHash[t.name] = {
          name: t.name,
          count: 0,
          placements: [],
          tiers: [],
        };
      }
      const h = traitsHash[t.name];
      h.count++;
      h.placements.push(participant.placement);
      h.tiers.push(t.tier_current);
    }
    for (const t of participant.units) {
      if (!unitsHash[t.character_id]) {
        unitsHash[t.character_id] = {
          name: t.character_id,
          count: 0,
          placements: [],
          tiers: [],
        };
      }
      const h = unitsHash[t.character_id];
      h.count++;
      h.placements.push(participant.placement);
      h.tiers.push(t.tier);
    }
    r.count++;
  }

  const traitsArray = Object.values(traitsHash);
  for (const t of traitsArray) {
    t.avgPlacement = t.placements.reduce(sumReduce, 0) / (t.count || 1);
    t.avgTier = t.tiers.reduce(sumReduce, 0) / (t.count || 1);
  }
  traitsArray.sort((a, b) => b.count - a.count);
  r.traits = traitsArray;

  const unitsArray = Object.values(unitsHash);
  for (const t of unitsArray) {
    t.avgPlacement = t.placements.reduce(sumReduce, 0) / (t.count || 1);
    t.avgTier = t.tiers.reduce(sumReduce, 0) / (t.count || 1);
  }
  unitsArray.sort((a, b) => b.count - a.count);
  r.units = unitsArray;

  r.avgPlacement = r.placements.reduce(sumReduce, 0) / (r.count || 1);
  return r;
}
